import {
  RECEIVED_MORNINGSTAR_ASSOCIATION,
  RECEIVED_MORNINGSTAR_ASSOCIATION_URL
} from './MorningstarActions';

export const morningstarInitialState = {};

export const morningstarReducer = (state = morningstarInitialState, action) => {
  if (action.type === RECEIVED_MORNINGSTAR_ASSOCIATION) {
    const { status, memberUrl } = action.payload;

    if (status) {
      return {
        status: status,
        memberUrl: memberUrl
      };
    }
  }

  if (action.type === RECEIVED_MORNINGSTAR_ASSOCIATION_URL) {
    const { memberUrl } = action.payload;

    if (memberUrl) {
      return {
        memberUrl: memberUrl
      };
    }
  }
  return state;
};
